// extracted by mini-css-extract-plugin
export default {"loader":"e000192009a8ed84","table":"_1a1b39d15f354a4e","count":"_60bf05a73fcac973","link":"_219091e00d37a21e","overdue":"_711842e79066d357"};